import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

const CardButtonProcess = ({
  title,
  children,
  background,
  to
}) => {

  const navigate = useNavigate()
  const handleNavigate = () => {
    navigate(to)
  }

  return (
    <div onClick={handleNavigate}
      className={`${background} rounded-md cursor-pointer border border-stroke py-6 px-7.5 shadow-sm shadow-blue-400 dark:border-strokedark dark:bg-boxdark transform transition-transform duration-300 hover:scale-105`}>
      <h1 className='text-center  uppercase font-bold p-3 '>{title}</h1>
      <div className="mt-4 flex h-18 items-center justify-center dark:bg-meta-4">
        {children}
      </div>
    </div>
  );
};

export default CardButtonProcess;
